import Http from '../../utils/Http';
import { Dispatch, AnyAction } from 'redux';
import * as Notification from '../../store/allStates/notification/actions';
import Transformer from '../../utils/Transformer';
import { admin_prefix } from '../../../configs/constant';

export function getNotifications(filter?: any) {
  return (dispatch: Dispatch<AnyAction>) =>
    new Promise((resolve, reject) => {
      Http.get(`${admin_prefix}notification`, { params: filter })
        .then((res) => {
          const data = Transformer.fetch(res.data);
          return resolve(data);
        })
        .catch((err) => {
          const statusCode = err.response.status;
          const data = {
            error: null,
            statusCode,
          };
          data.error = err.response.data;

          return reject(data);
        });
    });
}

export function addNotification(requestData: any) {
  return (dispatch: Dispatch<AnyAction>) =>
    new Promise((resolve, reject) => {
      Http.post(`${admin_prefix}notification`, requestData)
        .then((res) => {
          const data = Transformer.fetch(res.data);
          return resolve(data);
        })
        .catch((err) => {
          const statusCode = err.response.status;
          const data = {
            error: null,
            statusCode,
          };
          data.error = err.response.data;

          return reject(data);
        });
    });
}

export function updateNotification(slug: any, requestData: any) {
  return (dispatch: Dispatch<AnyAction>) =>
    new Promise((resolve, reject) => {
      Http.put(`${admin_prefix}notification/${slug}`, requestData)
        .then((res) => {
          const data = Transformer.fetch(res.data);
          return resolve(data);
        })
        .catch((err) => {
          const statusCode = err.response.status;
          const data = {
            error: null,
            statusCode,
          };
          data.error = err.response.data;

          return reject(data);
        });
    });
}

export function deleteNotification(slug: any) {
  return (dispatch: Dispatch<AnyAction>) =>
    new Promise((resolve, reject) => {
      Http.delete(`${admin_prefix}notification/${slug}`)
        .then((res) => {
          const data = Transformer.fetch(res.data);
          return resolve(data);
        })
        .catch((err) => {
          const statusCode = err.response.status;
          const data = {
            error: null,
            statusCode,
          };
          data.error = err.response.data;

          return reject(data);
        });
    });
}

export function deleteNotificationFromList(id: any) {
  return (dispatch: Dispatch<AnyAction>) =>
    new Promise((resolve, reject) => {
      Http.delete(`${admin_prefix}notification/list/${id}/remove-notification`)
        .then((res) => {
          const data = Transformer.fetch(res.data);
          return resolve(data);
        })
        .catch((err) => {
          const statusCode = err.response.status;
          const data = {
            error: null,
            statusCode,
          };
          data.error = err.response.data;

          return reject(data);
        });
    });
}

export function updateNotificationStatus(slug: any, requestData: any) {
  return (dispatch: Dispatch<AnyAction>) =>
    new Promise((resolve, reject) => {
      Http.post(`${admin_prefix}notification/${slug}/status`, requestData)
        .then((res) => {
          const data = Transformer.fetch(res.data);
          return resolve(data);
        })
        .catch((err) => {
          const statusCode = err.response.status;
          const data = {
            error: null,
            statusCode,
          };
          data.error = err.response.data;

          return reject(data);
        });
    });
}

export function getNotificationList(filter?: any) {
  return (dispatch: Dispatch<AnyAction>) =>
    new Promise((resolve, reject) => {
      Http.get(`${admin_prefix}notification/list`, { params: filter })
        .then((res) => {
          const data = Transformer.fetch(res.data);
          dispatch(Notification.list(data.data.rows));
          return resolve(data);
        })
        .catch((err) => {
          const statusCode = err.response.status;
          dispatch(Notification.list([]));
          const data = {
            error: null,
            statusCode,
          };
          data.error = err.response.data;

          return reject(data);
        });
    });
}

export function getReadNotificationList(id?: any) {
  return (dispatch: Dispatch<AnyAction>) =>
    new Promise((resolve, reject) => {
      Http.get(`${admin_prefix}notification/list/${id}/read-notification`)
        .then((res) => {
          const data = Transformer.fetch(res.data);
          return resolve(data);
        })
        .catch((err) => {
          const statusCode = err.response.status;
          const data = {
            error: null,
            statusCode,
          };
          data.error = err.response.data;

          return reject(data);
        });
    });
}

export function getReadBellIconNotificationList() {
  return (dispatch: Dispatch<AnyAction>) =>
    new Promise((resolve, reject) => {
      Http.get(`${admin_prefix}notification/list/read-bell-icon`)
        .then((res) => {
          const data = Transformer.fetch(res.data);
          return resolve(data);
        })
        .catch((err) => {
          const statusCode = err.response.status;
          const data = {
            error: null,
            statusCode,
          };
          data.error = err.response.data;

          return reject(data);
        });
    });
}

export function getMarkAllNotificationAsRead() {
  return (dispatch: Dispatch<AnyAction>) =>
    new Promise((resolve, reject) => {
      Http.get(`${admin_prefix}notification/list/mark-all-notification`)
        .then((res) => {
          const data = Transformer.fetch(res.data);
          return resolve(data);
        })
        .catch((err) => {
          const statusCode = err.response.status;
          const data = {
            error: null,
            statusCode,
          };
          data.error = err.response.data;

          return reject(data);
        });
    });
}
